<script lang="ts">
  import { run } from 'svelte/legacy';

  import CasinoSportSwitcher from "./CasinoSportSwitcher.svelte";
  import {user, userToken} from '$lib/stores'
  import {openDialog} from "$lib/stores/dialogStores";
  import type {IUser} from "$lib/interfaces/IUserMe";
  import Button from "$lib/elements/Button.svelte";
  import SearchIcon from "$lib/icons/SearchIcon.svelte";
  import LanguageSwitcher from "$lib/components/LanguageSwitcher.svelte";
  import {locale, translate} from '$lib/i18n';
  import TournamentsIcon from "$lib/icons/TournamentsIcon.svelte";
  import Cashier from "$lib/components/Cashier/Cashier.svelte";
  import Profile from "$lib/components/Profile.svelte";
  import Notifications from "$lib/components/Notifications/Notifications.svelte";
  import AfterHeaderBanner from "$lib/components/AfterHeaderBanner.svelte";
  import WalletIcon from "$lib/icons/WalletIcon.svelte";

  interface Props {
    data: any;
    gameMode?: boolean;
  }

  let { data, gameMode = false }: Props = $props();
  let token = $state(data?.token);
  let localUser: IUser | null = $state(data?.user);

  run(() => {
    if (!localUser) {
      localUser = $user;
    }

    if (!token) {
      token = $userToken
    }
  });

  function openLoginModal(name: string) {
    openDialog(name);
  }
</script>

<header
  class="bg-[#191D25] h-16 py-3 px-5 fixed w-full z-50 header container mx-auto flex justify-between items-center">
  <div class="flex  md:gap-x-2 lg:gap-x-12">
    <a href="{token ? (`/${$locale}/casino`) : `/${$locale}`}"
       class="text-[#FFFFFF] max-w-full text-[20px] font-bold">
      <enhanced:img src="$lib/logo.svg?enhanced" width="80" alt="Forza.bet"/>
    </a>
    <span class="hidden md:flex"><CasinoSportSwitcher/></span>
  </div>
  <div class="flex items-center gap-3 md:gap-4 lg:gap-6">
    <span class="md:flex hidden">
      <button onclick={() =>openDialog('SearchModal')}>
        <SearchIcon/>
      </button>
    </span>
    {#if localUser}
      <Cashier localUser={localUser}/>
      <span class="md:flex hidden">
        <button onclick={() => openDialog('TournamentsModal')}>
          <TournamentsIcon/>
        </button>
      </span>
      <Notifications localUser={localUser}/>
      <div class="hidden md:flex">
        <Profile localUser="{localUser}"/>
      </div>
<!--      <Button clas="py-2" on:click={() => openDialog('DepositModal')}>-->
<!--        <WalletIcon css="fill-white" />-->
<!--      </Button>-->
      <div class="md:hidden">
        <Profile localUser="{localUser}"/>
      </div>
    {:else}
      <Button on:click={() => openLoginModal('RegistrationModal')}
              variant="secondary">{$translate('register')}</Button>
      <Button on:click={() => openLoginModal('LoginModal')}>{$translate('login')}</Button>
    {/if}
    <span class="md:flex hidden">
      <LanguageSwitcher/>
    </span>
  </div>
</header>
{#if token}
  <AfterHeaderBanner {gameMode} {data} />
{/if}

<style>
  .header {
    box-shadow: 0 0 16px #000000;
  }
</style>
